import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './Botao.css';

/**
 * Variantes do botão.
 *
 * `destrutivo` é isolado de propósito: o sistema de design exige que ele fique
 * separado por divisor do primário e sempre peça confirmação.
 */
export type VarianteBotao =
  'primario' | 'secundario' | 'discreto' | 'sucesso' | 'sucesso-solido' | 'atencao' | 'destrutivo';

type Props = {
  readonly variante?: VarianteBotao;
  /** 36px é o padrão; `media` (34px) no cabeçalho, `pequena` (30px) nas ações de linha. */
  readonly altura?: 'padrao' | 'media' | 'pequena';
  readonly children: ReactNode;
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'>;

export function Botao({
  variante = 'secundario',
  altura = 'padrao',
  type = 'button',
  children,
  ...resto
}: Props) {
  return (
    <button className={`botao botao--${variante} botao--${altura}`} type={type} {...resto}>
      {children}
    </button>
  );
}
